<template lang="pug">
b-select(
  v-model="weekday"
  :expanded="expanded"
  @input="input"
)
  option(
    v-for="weekday in weekdays"
    :key="weekday"
    :value="weekday"
  ) {{ weekday }}
</template>

<script>
export default {
  name: 'weekday-select',
  created() {
    this.weekday = this.value || 'Sunday';
  },
  data() {
    return {
      weekday: null,
      weekdays: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
    };
  },
  methods: {
    input(val) {
      this.$emit('input', val);
    },
  },
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/WeekdaySelect.vue